import fluidvids from "fluidvids.js";
/* eslint-disable
    no-multi-assign,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
let ResponsiveVideos;

export default ResponsiveVideos = class ResponsiveVideos {
  constructor() {
    fluidvids.init({
      selector: ["iframe", "object"],
      players: [
        "c15119308.ssl.cf2.rackcdn.com",
        "youtube.com",
        "www.youtube.com",
        "player.vimeo.com",
        "maps.google.com",
        "youtube-nocookie.com",
      ],
    });
  }
};
